import React, { FC, useCallback, useEffect, useState } from 'react'
import { Column } from 'react-table'
import { Button, Checkbox, Container, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, makeStyles, MenuItem, Select, Typography } from '@material-ui/core'
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import Table from '../../components/Table'
import FormDialogWithDelete from "../../components/dialogs/FormDialogWithDelete"
import moment from "moment"
import "moment/locale/da"
import * as AlarmsAPI from '../../api/alarms/index'
import * as AlarmsModels from '../../api/alarms/models'
import * as ShortAPI from '../../api/short/index'
import * as ShortModels from '../../api/short/models'
import APIRequest from '../../components/helpers/APIRequest'

moment.locale("da")

const useStyles = makeStyles((theme) => ({
    paper: {
        [theme.breakpoints.up('sm')]: {
            padding: '0',
        },
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    buts: {
        width: '100%',
        height: '100%'
    },
    grid: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    textHelp: {
        marginBottom: '1rem'
    },
    margTop: {
        marginTop: theme.spacing(2),
    }
}))

interface Props {
    locationMap: Map<number, string>
    locationData: ShortModels.Location[]
}

const Plan: FC<Props> = ({locationMap, locationData}) => {
    const classes = useStyles()

    const [groups, setGroups] = useState<AlarmsModels.Group[]>([])
    const [isPendingGetGroups, setPendingGetGroups] = useState(false)
    const [runGetGroups, setRunGetGroups] = useState(true)
    const [groupMap, setGroupMap] = useState<Map<number, string>>(new Map<number, string>())

    const [users, setUsers] = useState<ShortModels.User[]>([])
    const [isPendingGetUsers, setPendingGetUsers] = useState(false)
    const [runGetUsers, setRunGetUsers] = useState(true)
    const [usersMap, setUsersMap] = useState<Map<number, {name: string, phone: string}>>(new Map<number, {name: string, phone: string}>())

    const [dutyPlan, setDutyPlan] = useState<AlarmsModels.Duty[]>([])
    const [isPendingGetDutyPlan, setPendingGetDutyPlan] = useState(false)
    const [runGetDutyPlan, setRunGetDutyPlan] = useState(true)

    // Dialog and related API control
    const [runRequestStoreDuty, setRunRequestStoreDuty] = useState(false)
    const [isPendingRequestStoreDuty, setPendingRunRequestStoreDuty] = useState(false)
    const [runRequestDeleteDuty, setRunRequestDeleteDuty] = useState(false)
    const [isPendingRequestDeleteDuty, setPendingRunRequestDeleteDuty] = useState(false)
    const [editDutyOpen, setEditDutyOpen] = useState(false)

    // Definitions for the edit dialog
    const [editDutyDialogTitle, setEditDutyDialogTitle] = useState("")
    const [editDutyDialogDeleteButtonText, setEditDutyDialogDeleteButtonText] = useState("")
    const [editDutyId, setEditDutyId] = useState(0)
    const [editDutyPersonId, setEditDutyPersonId] = useState(0)
    const [editDutyPersonPhone, setEditDutyPersonPhone] = useState(" ")
    const [editDutyGroupId, setEditDutyGroupId] = useState(0)
    const [editDutyOnDutyMonday, setEditDutyOnDutyMonday] = useState(false)
    const [editDutyOnDutyTuesday, setEditDutyOnDutyTuesday] = useState(false)
    const [editDutyOnDutyWednesday, setEditDutyOnDutyWednesday] = useState(false)
    const [editDutyOnDutyThursday, setEditDutyOnDutyThursday] = useState(false)
    const [editDutyOnDutyFriday, setEditDutyOnDutyFriday] = useState(false)
    const [editDutyOnDutySaturday, setEditDutyOnDutySaturday] = useState(false)
    const [editDutyOnDutySunday, setEditDutyOnDutySunday] = useState(false)
    const [editDutyStartTimeMonday, setEditDutyStartTimeMonday] = useState(new Date())
    const [editDutyStartTimeTuesday, setEditDutyStartTimeTuesday] = useState(new Date())
    const [editDutyStartTimeWednesday, setEditDutyStartTimeWednesday] = useState(new Date())
    const [editDutyStartTimeThursday, setEditDutyStartTimeThursday] = useState(new Date())
    const [editDutyStartTimeFriday, setEditDutyStartTimeFriday] = useState(new Date())
    const [editDutyStartTimeSaturday, setEditDutyStartTimeSaturday] = useState(new Date())
    const [editDutyStartTimeSunday, setEditDutyStartTimeSunday] = useState(new Date())
    const [editDutyEndTimeMonday, setEditDutyEndTimeMonday] = useState(new Date())
    const [editDutyEndTimeTuesday, setEditDutyEndTimeTuesday] = useState(new Date())
    const [editDutyEndTimeWednesday, setEditDutyEndTimeWednesday] = useState(new Date())
    const [editDutyEndTimeThursday, setEditDutyEndTimeThursday] = useState(new Date())
    const [editDutyEndTimeFriday, setEditDutyEndTimeFriday] = useState(new Date())
    const [editDutyEndTimeSaturday, setEditDutyEndTimeSaturday] = useState(new Date())
    const [editDutyEndTimeSunday, setEditDutyEndTimeSunday] = useState(new Date())

    useEffect(() => {
        // When the group list is downloaded, create the group map ID->name
        let newMap: Map<number, string> = new Map<number, string>()
        groups.forEach(group => {
            newMap.set(group.id, group.name)
        })
        setGroupMap(newMap)
    }, [groups])

    useEffect(() => {
        // When the user list is downloaded, create the user map ID->{name, phone}
        let newMap: Map<number, {name: string, phone: string}> = new Map<number, {name: string, phone: string}>()
        users.forEach(user => {
            newMap.set(user.id, {name: user.name, phone: user.phone})
        })
        setUsersMap(newMap)
    }, [users])

    const renderGroupCell = useCallback((groupId: number) => {
        return groupMap.get(groupId)
    }, [groupMap])

    const renderUserName = useCallback((personId: number) => {
        var user = usersMap.get(personId)
        if (user) {
            return user.name
        }
        return ""
    }, [usersMap])

    const renderUserPhone = useCallback((personId: number) => {
        const user = usersMap.get(personId)
        if (user) {
            return user.phone
        }
        return ""
    }, [usersMap])

    const renderDutyPlan = (mon: AlarmsModels.DutyTime, tue: AlarmsModels.DutyTime, wed: AlarmsModels.DutyTime, thu: AlarmsModels.DutyTime, fri: AlarmsModels.DutyTime, sat: AlarmsModels.DutyTime, sun: AlarmsModels.DutyTime) => {
        function renderTime(day: string, t: AlarmsModels.DutyTime): string {
            let s: string = day + " " + t.startHour
            if (t.startMinute > 0) {
                s += ":" + t.startMinute
            }
            s += " - " + t.endHour
            if (t.endMinute > 0) {
                s += ":" + t.endMinute
            }
            return s
        }

        let plan: string[] = []
        if (mon.onDuty) { plan.push(renderTime("Mandag ", mon))}
        if (tue.onDuty) { plan.push(renderTime("Tirsdag ", tue))}
        if (wed.onDuty) { plan.push(renderTime("Onsdag ", wed))}
        if (thu.onDuty) { plan.push(renderTime("Torsdag ", thu))}
        if (fri.onDuty) { plan.push(renderTime("Fredag ", fri))}
        if (sat.onDuty) { plan.push(renderTime("Lørdag ", sat))}
        if (sun.onDuty) { plan.push(renderTime("Søndag ", sun))}
        return plan.join(", ")
    }

    const columns: Column<AlarmsModels.Duty>[] = React.useMemo(() => [
        { Header: 'Navn', id: "0", accessor: g => renderUserName(g.personId) },
        { Header: 'Mobiltelefon', id: "1", accessor: g => renderUserPhone(g.personId) },
        { Header: 'Gruppering', id: "2", accessor: g => renderGroupCell(g.groupId) },
        { Header: 'Vagtplan', id: "3", accessor: g => renderDutyPlan(g.mon, g.tue, g.wed, g.thu, g.fri, g.sat, g.sun) },
    ], [renderGroupCell, renderUserName, renderUserPhone])

    const handleClickNewDuty = () => {
        handleRowClick(new AlarmsModels.Duty())
    }

    const handleRowClick = (element: AlarmsModels.Duty) => {
        setEditDutyId(element.id)
        if (element.id > 0) {
            setEditDutyDialogTitle("Ændring af vagt")
            setEditDutyDialogDeleteButtonText("Slet vagt")
            setEditDutyPersonId(element.personId)
            setEditDutyGroupId(element.groupId)
        } else {
            setEditDutyDialogTitle("Ny vagt")
            setEditDutyDialogDeleteButtonText("")
            if (users.length > 0) {
                setEditDutyPersonId(users[0].id)
            } else {
                setEditDutyPersonId(0)
            }
            if (groups.length > 0) {
                setEditDutyGroupId(groups[0].id)
            } else {
                setEditDutyGroupId(0)
            }
        }

        const setEditDialogDutyParts = (duty: AlarmsModels.DutyTime, setOnDuty: (value: React.SetStateAction<boolean>) => void, setStartTime: (value: React.SetStateAction<Date>) => void, setEndTime: (value: React.SetStateAction<Date>) => void) => {
            setOnDuty(duty.onDuty)
            var t = new Date()
            t.setHours(duty.startHour)
            t.setMinutes(duty.startMinute)
            setStartTime(t)
            t = new Date()
            t.setHours(duty.endHour)
            t.setMinutes(duty.endMinute)
            setEndTime(t)
        }

        setEditDialogDutyParts(element.mon, setEditDutyOnDutyMonday, setEditDutyStartTimeMonday, setEditDutyEndTimeMonday)
        setEditDialogDutyParts(element.tue, setEditDutyOnDutyTuesday, setEditDutyStartTimeTuesday, setEditDutyEndTimeTuesday)
        setEditDialogDutyParts(element.wed, setEditDutyOnDutyWednesday, setEditDutyStartTimeWednesday, setEditDutyEndTimeWednesday)
        setEditDialogDutyParts(element.thu, setEditDutyOnDutyThursday, setEditDutyStartTimeThursday, setEditDutyEndTimeThursday)
        setEditDialogDutyParts(element.fri, setEditDutyOnDutyFriday, setEditDutyStartTimeFriday, setEditDutyEndTimeFriday)
        setEditDialogDutyParts(element.sat, setEditDutyOnDutySaturday, setEditDutyStartTimeSaturday, setEditDutyEndTimeSaturday)
        setEditDialogDutyParts(element.sun, setEditDutyOnDutySunday, setEditDutyStartTimeSunday, setEditDutyEndTimeSunday)
        setEditDutyOpen(true)
    }

    const RequestGetGroups = () => {
        return (<APIRequest<AlarmsModels.Group[]>
            run={runGetGroups} setRun={setRunGetGroups}
            pending={isPendingGetGroups} setIsPending={setPendingGetGroups}
            req={AlarmsAPI.getGroups}
            setData={setGroups}
        />)
    }

    const RequestGetUsers = () => {
        return (<APIRequest<ShortModels.User[]>
            run={runGetUsers} setRun={setRunGetUsers}
            pending={isPendingGetUsers} setIsPending={setPendingGetUsers}
            req={ShortAPI.getUsers}
            setData={setUsers}
            />
        )
    }

    const RequestGetDutyPlan = () => {
        return (<APIRequest<AlarmsModels.Duty[]>
            run={runGetDutyPlan} setRun={setRunGetDutyPlan}
            pending={isPendingGetDutyPlan} setIsPending={setPendingGetDutyPlan}
            req={AlarmsAPI.getDutyPlans}
            setData={setDutyPlan}
        />)
    }

    const RequestStoreDuty = () => {
        // Store new duty
        return (<APIRequest<AlarmsModels.Duty[]>
            run={runRequestStoreDuty} setRun={setRunRequestStoreDuty}
            pending={isPendingRequestStoreDuty} setIsPending={setPendingRunRequestStoreDuty}
            setData={setDutyPlan}
            req={() => AlarmsAPI.storeDuty({id: editDutyId, personId: editDutyPersonId, groupId: editDutyGroupId,
                mon: new AlarmsModels.DutyTime(editDutyOnDutyMonday, editDutyStartTimeMonday.getHours(), editDutyStartTimeMonday.getMinutes(), editDutyEndTimeMonday.getHours(), editDutyEndTimeMonday.getMinutes()),
                tue: new AlarmsModels.DutyTime(editDutyOnDutyTuesday, editDutyStartTimeTuesday.getHours(), editDutyStartTimeTuesday.getMinutes(), editDutyEndTimeTuesday.getHours(), editDutyEndTimeTuesday.getMinutes()),
                wed: new AlarmsModels.DutyTime(editDutyOnDutyWednesday, editDutyStartTimeWednesday.getHours(), editDutyStartTimeWednesday.getMinutes(), editDutyEndTimeWednesday.getHours(), editDutyEndTimeWednesday.getMinutes()),
                thu: new AlarmsModels.DutyTime(editDutyOnDutyThursday, editDutyStartTimeThursday.getHours(), editDutyStartTimeThursday.getMinutes(), editDutyEndTimeThursday.getHours(), editDutyEndTimeThursday.getMinutes()),
                fri: new AlarmsModels.DutyTime(editDutyOnDutyFriday, editDutyStartTimeFriday.getHours(), editDutyStartTimeFriday.getMinutes(), editDutyEndTimeFriday.getHours(), editDutyEndTimeFriday.getMinutes()),
                sat: new AlarmsModels.DutyTime(editDutyOnDutySaturday, editDutyStartTimeSaturday.getHours(), editDutyStartTimeSaturday.getMinutes(), editDutyEndTimeSaturday.getHours(), editDutyEndTimeSaturday.getMinutes()),
                sun: new AlarmsModels.DutyTime(editDutyOnDutySunday, editDutyStartTimeSunday.getHours(), editDutyStartTimeSunday.getMinutes(), editDutyEndTimeSunday.getHours(), editDutyEndTimeSunday.getMinutes())})}
        />)
    }

    const RequestDeleteDuty = () => {
        return (<APIRequest<AlarmsModels.Duty[]>
            run={runRequestDeleteDuty} setRun={setRunRequestDeleteDuty}
            pending={isPendingRequestDeleteDuty} setIsPending={setPendingRunRequestDeleteDuty}
            req={() => AlarmsAPI.deleteDuty(editDutyId)}
            setData={setDutyPlan}
        />)
    }

    // Update the phone number with the chosen user in the edit dialog
    useEffect(() => {
        var user = usersMap.get(editDutyPersonId)
        if (user && user.phone.length > 0) {
            setEditDutyPersonPhone("Tlf: " + user.phone)
        } else {
            setEditDutyPersonPhone(" ")
        }
    }, [editDutyPersonId, usersMap])

    // Create a line day checkbox part for the edit dialog
    const createDayLineDay = (dayShort: string, dayLong: string, onDuty: boolean, setOnDuty: (value: React.SetStateAction<boolean>) => void) => {
        return (<Grid item xs={4} >
            <FormControlLabel
                control={<Checkbox name={dayShort} id={dayShort} label={dayLong} checked={onDuty} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setOnDuty(e.currentTarget.checked)}} />}
                label={dayLong} />
            </Grid>)
    }

    // Create a line time part for the edit dialog
    const createDayLineTime = (label: string, onDuty: boolean, value: Date, setValue: (value: React.SetStateAction<Date>) => void) => {
        return (<Grid item xs={4}>
            <TimePicker disabled={!onDuty} ampm={false} openTo="hours" views={['hours', 'minutes']} format="HH:mm" label={label}
                value={value} onChange={(d: Date | null) => { if (d) setValue(d)}} cancelLabel="Afbryd" okLabel="OK" />
            </Grid>)
    }

    return (
        <Container maxWidth={false}>
            <RequestGetGroups />
            <RequestGetUsers />
            <RequestGetDutyPlan />
            <RequestStoreDuty />
            <RequestDeleteDuty />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">Vagtplan</Typography>
                <div className={classes.paper}>
                    <Button disabled={groups.length < 1} variant="contained" color="primary" className={classes.buts} onClick={handleClickNewDuty}>Ny vagt</Button>
                </div>
                <div className={classes.grid}>
                    <Table<AlarmsModels.Duty> columns={columns} data={dutyPlan} initialState={{pageSize: 150}} clickEvent={handleRowClick} update={null} pending={false} text={""}/>
                </div>
            </div>

            <FormDialogWithDelete title={editDutyDialogTitle} open={editDutyOpen} deleteText={editDutyDialogDeleteButtonText} saveText="Gem vagt"
                    onClose={() => setEditDutyOpen(false)} onCloseSubmit={() => setRunRequestStoreDuty(true)} onCloseDelete={() => setRunRequestDeleteDuty(true)}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <InputLabel id="edit-dialog-sms-alarm-person-label">Vagt</InputLabel>
                                <Select labelId="edit-dialog-sms-alarm-person-label" id="edit-dialog-sms-alarm-person" value={editDutyPersonId} onChange={(event: React.ChangeEvent<{ value: unknown }>) => {setEditDutyPersonId(event.target.value as number)}}>
                                    {users.sort((a, b) => (a.name > b.name) ? 1 : -1).map((user) => {
                                        return <MenuItem key={`PersonId-${user.id}`} value={user.id}>{user.name}</MenuItem>
                                    })}
                                </Select>
                                <FormHelperText>{editDutyPersonPhone}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <InputLabel id="edit-dialog-sms-alarm-group-label">Gruppering</InputLabel>
                                <Select labelId="edit-dialog-sms-alarm-group-label" id="edit-dialog-sms-alarm-group" value={editDutyGroupId} onChange={(event: React.ChangeEvent<{ value: unknown }>) => {setEditDutyGroupId(event.target.value as number)}}>
                                    {groups.sort((a, b) => (a.name > b.name) ? 1 : -1).map((group) => {
                                        return <MenuItem key={`GroupId-${group.id}`} value={group.id}>{group.name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}></Grid>
                        {createDayLineDay("mon", "Mandag", editDutyOnDutyMonday, setEditDutyOnDutyMonday)}
                        {createDayLineTime("Start", editDutyOnDutyMonday, editDutyStartTimeMonday, setEditDutyStartTimeMonday)}
                        {createDayLineTime("Slut", editDutyOnDutyMonday, editDutyEndTimeMonday, setEditDutyEndTimeMonday)}
                        {createDayLineDay("tue", "Tirsdag", editDutyOnDutyTuesday, setEditDutyOnDutyTuesday)}
                        {createDayLineTime("Start", editDutyOnDutyTuesday, editDutyStartTimeTuesday, setEditDutyStartTimeTuesday)}
                        {createDayLineTime("Slut", editDutyOnDutyTuesday, editDutyEndTimeTuesday, setEditDutyEndTimeTuesday)}
                        {createDayLineDay("wed", "Onsdag", editDutyOnDutyWednesday, setEditDutyOnDutyWednesday)}
                        {createDayLineTime("Start", editDutyOnDutyWednesday, editDutyStartTimeWednesday, setEditDutyStartTimeWednesday)}
                        {createDayLineTime("Slut", editDutyOnDutyWednesday, editDutyEndTimeWednesday, setEditDutyEndTimeWednesday)}
                        {createDayLineDay("thu", "Torsdag", editDutyOnDutyThursday, setEditDutyOnDutyThursday)}
                        {createDayLineTime("Start", editDutyOnDutyThursday, editDutyStartTimeThursday, setEditDutyStartTimeThursday)}
                        {createDayLineTime("Slut", editDutyOnDutyThursday, editDutyEndTimeThursday, setEditDutyEndTimeThursday)}
                        {createDayLineDay("fri", "Fredag", editDutyOnDutyFriday, setEditDutyOnDutyFriday)}
                        {createDayLineTime("Start", editDutyOnDutyFriday, editDutyStartTimeFriday, setEditDutyStartTimeFriday)}
                        {createDayLineTime("Slut", editDutyOnDutyFriday, editDutyEndTimeFriday, setEditDutyEndTimeFriday)}
                        {createDayLineDay("sat", "Lørdag", editDutyOnDutySaturday, setEditDutyOnDutySaturday)}
                        {createDayLineTime("Start", editDutyOnDutySaturday, editDutyStartTimeSaturday, setEditDutyStartTimeSaturday)}
                        {createDayLineTime("Slut", editDutyOnDutySaturday, editDutyEndTimeSaturday, setEditDutyEndTimeSaturday)}
                        {createDayLineDay("sun", "Søndag", editDutyOnDutySunday, setEditDutyOnDutySunday)}
                        {createDayLineTime("Start", editDutyOnDutySunday, editDutyStartTimeSunday, setEditDutyStartTimeSunday)}
                        {createDayLineTime("Slut", editDutyOnDutySunday, editDutyEndTimeSunday, setEditDutyEndTimeSunday)}
                    </Grid>
                </MuiPickersUtilsProvider>
            </FormDialogWithDelete>
        </Container>
    )
}

export default Plan
